import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFocusLock"><Path d="M9 3H3V9H5V5H9V3Z" fill="currentColor"/><Path d="M21 3H15V5H19V9H21V3Z" fill="currentColor"/><Path d="M5 19V15H3V21H9V19H5Z" fill="currentColor"/><Path d="M21 21V15H19V19H15V21H21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 10H16V16H8V10H9C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusLock;
